import Menu from '../components/Menu';
import GlobalStyles from "../assets/css/global";
import styled from 'styled-components';
import { useState, createContext, useContext } from 'react';

// Context para compartilhar o estado da sidebar
const SidebarContext = createContext();

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

const MainContent = styled.div`
  margin-top: 60px; /* Altura do header fixo */
  transition: margin-left 0.3s ease;
  
  @media (min-width: 768px) {
    margin-left: ${props => props.sidebarOpen ? '250px' : '0'}; /* Largura da sidebar */
    margin-top: 60px;
  }
  
  @media (max-width: 767px) {
    margin-top: 80px; /* Altura maior para mobile quando os elementos quebram */
  }
  
  @media print {
    margin-top: 0;
    margin-left: 0;
  }
`;

export default function Template(props) {
    // Permitir definir o estado inicial da sidebar via prop
    const initialOpen = (typeof props.initialSidebarOpen !== 'undefined')
        ? props.initialSidebarOpen
        : (window.innerWidth >= 768);

    const [sidebarOpen, setSidebarOpen] = useState(initialOpen);

    return(
        <SidebarContext.Provider value={{ sidebarOpen, setSidebarOpen }}>
            <GlobalStyles />
            <Menu />
            <MainContent sidebarOpen={sidebarOpen}>
                {props.children}
            </MainContent>
        </SidebarContext.Provider>
    )
}